// @ts-nocheck
import * as React from "react";
import { Suspense } from "react";
import "./App.css";
import "./pages/Concourse/style.less";
import { inject, observer } from "mobx-react";
import Centered from "./common/Centered";
import {
  HashRouter,
  matchPath,
  Route,
  RouteComponentProps,
  withRouter,
} from "react-router-dom";
import { injectMainStore, MainStoreInjected } from "@cuba-platform/react";
import { CenteredLoader } from "./CenteredLoader";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { cubaREST, RootStoreProp } from "./store";
import { MOBILE_ROUTES } from "./mobile-routes";
import moment from "moment/moment";

const MobileAuthPage = React.lazy(
  () => import("./pages/mobile-auth/mobile-auth.page"),
);
const AppRoutes = React.lazy(() => import("./appRoutes"));
const Login = React.lazy(() => import("./login/Login"));

const setLocale = async (locale: string) => {
  const finalLocale = locale === "kz" ? "kk" : locale;

  switch (finalLocale) {
    case "kk":
      await import("moment/locale/kk");
      break;
    case "ru":
      await import("moment/locale/ru");
      break;
  }

  moment.locale(finalLocale);
};

@injectMainStore
@inject("rootStore")
@observer
class AppComponent extends React.Component<
  MainStoreInjected &
    WrappedComponentProps &
    RootStoreProp &
    RouteComponentProps
> {
  render() {
    const { initialized, locale, metadata, messages, authenticated } =
      this.props.mainStore;

    if (
      !initialized ||
      !locale ||
      !this.props.rootStore?.userInfo.initialized
    ) {
      return <CenteredLoader />;
    }

    const hashString = window.location.hash;

    if (hashString.includes("mobile-auth")) {
      return (
        <HashRouter>
          <Route path={"/" + MOBILE_ROUTES.mobileAuth} exact>
            <Suspense fallback={<CenteredLoader />}>
              <MobileAuthPage mainStore={this.props.mainStore} />
            </Suspense>
          </Route>
        </HashRouter>
      );
    }

    if (!authenticated) {
      return (
        <div>
          <Centered>
            <Suspense fallback={<CenteredLoader />}>
              <Login />
            </Suspense>
          </Centered>
        </div>
      );
    }

    if (cubaREST.loadMetadata && (!metadata || !messages)) {
      return <CenteredLoader />;
    }

    const path = this.props.history.location.pathname.slice(1);

    const isMobileRoute = Object.values(MOBILE_ROUTES).some((route) => {
      return !!matchPath(path, {
        path: route,
        exact: true,
      });
    });

    setLocale(locale);
    return (
      <>
        <Suspense fallback={<CenteredLoader />}>
          <AppRoutes isMobile={isMobileRoute} />
        </Suspense>
      </>
    );
  }

  componentDidUpdate(
    prevProps: MainStoreInjected &
      WrappedComponentProps &
      RootStoreProp &
      RouteComponentProps,
  ) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }
}

const App = injectIntl(withRouter(AppComponent));
export default App;
